/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const CustomerFacingContacts = z.object({ primary: z.string(), secondary: z.string() })

export interface CustomerFacingContacts extends z.TypeOf<typeof CustomerFacingContacts> {}
